import { useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'

import { postOrdersDetailsWestfieldConsAPI } from 'api/orders-details-westfieldcons'
import { OrdersWestfieldConsDataTypes } from 'types/orders-westfieldcons'

import { DATASTATUS } from 'constants/status'

export const useOrdersDetails = ({
  dataTableSelectedRow,
}: {
  dataTableSelectedRow: OrdersWestfieldConsDataTypes | null
}) => {
  const orderId = dataTableSelectedRow?.orderId

  const { data, isLoading, isError, isSuccess } = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useOrdersDetails', orderId],
    enabled: !!orderId,
    queryFn: async () => {
      try {
        const response = await postOrdersDetailsWestfieldConsAPI({ orderId })
        if (response.outcomeCode === DATASTATUS.outcomeCode) throw response
        return response.data
      } catch (e) {
        return null
      }
    },
  })

  return {
    data,
    isLoading,
    isError,
    isSuccess,
  }
}
